import React from 'react';
import { ArrowUp } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_innovate-ghana-tech/artifacts/0dmqxsnu_0e0a97331ac163b7d8d3f4fa458da7ea9f7b5c35ae763d1673b82962b564a212.png";

export default function Footer() {
  const { t } = useLang();
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const handleNav = (href) => { const el = document.querySelector(href); if (el) el.scrollIntoView({ behavior: 'smooth' }); };

  const footerLinks = {
    services: [
      { label: t.services.s1, href: '#services' },
      { label: t.services.s4, href: '#services' },
      { label: t.services.s3, href: '#services' },
      { label: t.services.s5, href: '#services' },
      { label: t.services.s6, href: '#services' },
    ],
    ecosystem: [
      { label: 'EAA', href: '#produits' },
      { label: 'SDM REWARDS', href: '#produits' },
      { label: 'GIT GHANA SECURITY', href: '#produits' },
      { label: 'GIT ESTATE', href: '#produits' },
      { label: 'Best in Singapore', href: '#produits' },
      { label: 'Global IT Corp', href: '#produits' },
      { label: 'JAPAP Messenger', href: '#produits' },
      { label: 'Propesia360', href: '#produits' },
    ],
    company: [
      { label: t.nav.about, href: '#apropos' },
      { label: t.nav.services, href: '#services' },
      { label: t.nav.blog, href: '#blog' },
      { label: t.nav.contact, href: '#contact' },
    ],
  };

  return (
    <footer data-testid="footer" className="bg-[#0B132B] text-white pt-20 pb-8 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="lg:col-span-4">
            <img src={LOGO_URL} alt="GIT NFT GHANA" className="h-14 w-auto mb-6" />
            <p className="text-[#94A3B8] text-sm leading-relaxed max-w-xs mb-6">{t.footer.desc}</p>
            <div className="flex gap-3">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-white/50 hover:text-[#00D186] hover:border-[#00D186]/30 transition-colors">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" data-testid="footer-twitter" className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-white/50 hover:text-[#00D186] hover:border-[#00D186]/30 transition-colors">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-white/50 hover:text-[#00D186] hover:border-[#00D186]/30 transition-colors">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
            </div>
          </div>
          <div className="lg:col-span-3">
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">{t.footer.servicesTitle}</h4>
            <ul className="space-y-3">{footerLinks.services.map((l) => (<li key={l.label}><button onClick={() => handleNav(l.href)} className="text-[#94A3B8] text-sm hover:text-[#00D186] transition-colors">{l.label}</button></li>))}</ul>
          </div>
          <div className="lg:col-span-2">
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">{t.footer.ecosystemTitle}</h4>
            <ul className="space-y-3">{footerLinks.ecosystem.map((l) => (<li key={l.label}><button onClick={() => handleNav(l.href)} className="text-[#94A3B8] text-sm hover:text-[#00D186] transition-colors">{l.label}</button></li>))}</ul>
          </div>
          <div className="lg:col-span-3">
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">{t.footer.companyTitle}</h4>
            <ul className="space-y-3">{footerLinks.company.map((l) => (<li key={l.label}><button onClick={() => handleNav(l.href)} className="text-[#94A3B8] text-sm hover:text-[#00D186] transition-colors">{l.label}</button></li>))}</ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#94A3B8] text-sm">&copy; {new Date().getFullYear()} GIT NFT GHANA LTD. {t.footer.rights}</p>
          <button onClick={scrollToTop} data-testid="scroll-to-top" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/50 hover:text-[#00D186] hover:border-[#00D186]/30 transition-all hover:-translate-y-1"><ArrowUp size={18} /></button>
        </div>
      </div>
    </footer>
  );
}
